// extracted by mini-css-extract-plugin
export default {"omnie":"Omnie_omnie__acr4h"};